module.exports = __webpack_public_path__ + "img/csharplogo.cccaa90e.svg";